import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SetUpDataService } from '../pages/set-up/services/set-up-data.service';
import { MessageService } from './../shared/services/message.service'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';



@Component({
	selector: 'app-mdms-dialog',
	templateUrl: './mdms-dialog.component.html',
	styleUrls: ['./mdms-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MdmsDialogComponent {
	requestBody: any;
	isHoveredDownload: boolean = false;  // Flag for hover state of download button
	isHoveredUpload: boolean = false;
	alertDict: any;
	fileName: string = '';
	fileSelected: boolean = false;
	invalidFileType: boolean = false;
	invalidFileSize: boolean = false;
	invalidFileName: boolean = false;
	fileNotAvailable: boolean = false;
	allowedFileSize: number = 104857600; //Bytes = 100 MB
	allowedFileTypes: string[] = ['xls', 'xlsx', 'csv', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xlt', 'xlam']
	fileStatus: boolean = false;
	file: File;
	saveFlag: boolean = true;
	actionBtn: string = "Upload File";
	fileFlag: boolean = false;
	download: boolean = false;

	date = new Date().toLocaleDateString('en-US', {
		weekday: 'short',  // Mon
		year: 'numeric',   // 2024
		month: 'short',    // Sep
		day: 'numeric'     // 2
	});
	time = new Date().toLocaleTimeString();
	// lastUpdatedOn: string = `${this.date}, ${this.time}`;

	latestVersion: string = '';
	lastUpdatedBy: string = '';
	lastUpdatedOn: string = '';
	loaded: boolean = false;
	progress: boolean = false;


	constructor(@Inject(DOCUMENT) private document: Document, private api: SetUpDataService, private message: MessageService, private cdr: ChangeDetectorRef,
		private dialogRef: MatDialogRef<MdmsDialogComponent>, private http: HttpClient) { }


	private user: any;
	ngOnInit(): void {
		this.getMdmsRecord();
		this.preloadImages();
		this.user = JSON.parse(localStorage.getItem('loggedInUserDetails'));

	}
	preloadImages() {
		const images = [
			'./../../../../assets/images/icons/mdmsLoadHover.svg',
			'./../../../../assets/images/icons/mdmsLoad.svg',
			'./../../../../assets/images/icons/mdmsUploadHover.svg',
			'./../../../../assets/images/icons/mdmsUpload.svg'
		];
		images.forEach((src) => {
			const img = new Image();
			img.src = src;
		});
	}


	getMdmsRecord() {
		this.api.getMdmsRecord().subscribe({
			next: (res) => {
				const metadata = res?.Response?.ResponseMetadata;

				if (metadata?.Status === 'E') {
					const errorMessage = metadata?.Description || 'An unknown error occurred.';
					this.latestVersion = '';
					this.lastUpdatedBy = '';
					this.lastUpdatedOn = '';
					console.error('MDMS Error:', errorMessage);
				} else {
					const mdms = res?.Response?.MdmsUploadURL;
					this.latestVersion = mdms?.next_version ?? 'N/A';
					this.lastUpdatedBy = mdms?.last_uploaded_by ?? 'N/A';
					this.lastUpdatedOn = mdms?.last_uploaded_on ?? 'N/A';
				}
				this.loaded = true;
				this.cdr.detectChanges();
			},
			error: (e) => {
				// Network or unexpected error
				console.error('API call failed:', e);
				this.latestVersion = '';
				this.lastUpdatedBy = '';
				this.lastUpdatedOn = '';
				this.loaded = true;
			}
		});
	}


	getStaticPresignedURL() {
		this.loaded = false;
		this.download = true;
		this.api.getStaticPresignedURLForMdms("Mdms")
			.subscribe({
				next: (res) => {
					let url = res["Response"]["PresignedURL"];
					const link = document.createElement('a');
					link.setAttribute('target', '_blank');
					link.setAttribute('href', url);
					link.setAttribute('download', `template.csv`);
					document.body.appendChild(link);
					link.click();
					link.remove();
					this.dialogRef.close('close');
				},
				error: (e) => {
					this.alertDict = { 'alertMessage': `Some unknown error occured`, 'alertType': 'danger' }
					this.showLoader = false;
					this.loaderMessage = '';
					this.dialogRef.close('close');
					this.message.sendMessage(this.alertDict);
				}
			})
	}

	/**
	 * Function to check file type and upload 
	 * @param event event
	 */
	onFileSelected(event) {
		this.file = event.target.files[0];
		let filenamepattern = /^[^.]*\.[^.]*$/;
		const file: File = event.target.files[0];
		if (file) {
			this.fileName = file.name;
			this.fileSelected = true;
		} else {
			this.fileSelected = false;
		}
		if (!filenamepattern.test(this.file.name)) {
			this.invalidFileName = true;
		}
		else if (this.file && this.allowedFileTypes.includes(this.file.name.split('.').pop())) {
			if (this.allowedFileSize >= this.file.size) {
				this.fileName = this.file.name;
				this.fileStatus = true;
				this.fileNotAvailable = false;
				const formData = new FormData();
				this.invalidFileSize = false;
				formData.append("thumbnail", this.file);
				this.invalidFileType = false;
				this.saveFlag = true;
				this.actionBtn = "Upload File";
				this.fileFlag = true;
			}
			else {
				this.fileName = '';
				this.invalidFileSize = true;
			}
			this.invalidFileName = false;
		}
		else if (!this.allowedFileTypes.includes(this.file.name.split('.').pop())) {
			this.fileName = '';
			this.invalidFileType = true;
			this.invalidFileName = false;
		}
	}

	loaderMessage = '';

	showLoader = false;
	loaderMessages: string[] = [];
	progressValue = 0;

	allDone = false;

	startLoaderMessages() {
		this.showLoader = true;
		this.allDone = false;
		this.loaderMessages = [];

		const messages = [
			'Reading MDMS template',
			'Checking MDMS version',
			'Updating therapy area(s)',
			'Updating disease area(s)',
			'Updating indication(s)',
			'Updating brand(s)',
			'Updating geographies',
			'Configuring Forecast Manager'
		];

		let index = 0;

		const interval = setInterval(() => {
			if (index < messages.length) {
				this.loaderMessages.push(messages[index]);
				index++;
				this.cdr.detectChanges();
			}

			if (index === messages.length) {
				clearInterval(interval);
				setTimeout(() => {
					this.allDone = true;
					this.cdr.detectChanges();
				}, 1000); // Allow a pause before showing the final tick
			}
		}, 2000);
	}

	addMdms() {

		if (!this.saveFlag) {
			return;
		}
		else
			this.saveFlag = false;
		this.startLoaderMessages(); // Start the loader messages

		if (this.actionBtn == "Upload File") {
			this.getFileURL();
		}
	}

	getFileURL() {
		this.api.getMdmsUploadURL()
			.subscribe({
				next: (res) => {
					this.uploadFile(res["Response"]["MdmsUploadURL"]);
				},
				error: (e) => {
					console.log(e)
					this.saveFlag = true;
					this.showLoader = false;
					this.loaderMessage = '';
				}
			})
	}

	uploadFile(presignedURL) {

		this.http.put<any>(presignedURL, this.file.slice()).toPromise().then((response) => {
			this.addMdmsFile();
		},
			(error) => {
				this.saveFlag = true;
				console.error('There was an error uploading file to S3!', error);
				this.showLoader = false;
				this.loaderMessage = '';
				return false;
			});
	}

	addMdmsFile() {
		this.requestBody = {
			"Request": {
				"CreatedBy": this.user.UserName,
				"CreatedOn": new Date().toISOString(),
			}
		}
		this.api.addMdms(this.requestBody)
			.subscribe({
				next: (res) => {
					let msg = '';
					const response = res.Response;
					// Check if the message is not empty before displaying it
					if (response.ResponseMetadata && response.ResponseMetadata.Status == 'S') {
						// Display the message using your toaster or other UI component
						this.alertDict = { 'alertMessage': `File has been uploaded successfully! ${msg}`, 'alertType': 'success' }
					}
					else {
						this.alertDict = { 'alertMessage': `File has been uploaded successfully!`, 'alertType': 'success' }
					}
					this.saveFlag = true;
					this.showLoader = false;
					this.loaderMessage = '';
					this.dialogRef.close('add');
					this.message.sendMessage(this.alertDict);
					// alert("User added successfully");

				},
				error: (res) => {
					this.saveFlag = true;
					this.alertDict = { 'alertMessage': `Error: ${res.error.Response.ResponseMetadata.Description}`, 'alertType': 'danger' }
					this.showLoader = false;
					this.loaderMessage = '';
					// this.alertDict = { 'alertMessage': `There has been an error`, 'alertType': 'danger' }
					this.dialogRef.close('close');
					this.message.sendMessage(this.alertDict);
				}
			})
	}


}
